<!-- @veltra/icons generated sha256:2eec55651a9b9a13 gen:8 source:src/svg/normal/money-circle.svg -->
<script setup lang="ts">
defineOptions({ name: 'MoneyCircle' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 13A6 6 0 1 0 8 2a6 6 0 0 0 0 12m.5-6.5h1.49a.51.51 0 0 0 .51-.496.497.497 0 0 0-.493-.504H9.04l1.033-1.29a.51.51 0 0 0-.07-.708.51.51 0 0 0-.711.083L8 6.2 6.708 4.585a.495.495 0 0 0-.696-.094l-.01.007a.51.51 0 0 0-.075.711L6.96 6.5h-.967a.496.496 0 0 0-.493.496c0 .276.234.504.51.504H7.5v1H6.01a.51.51 0 0 0-.51.496c0 .276.234.504.51.504H7.5v2.007c0 .276.228.493.496.493a.5.5 0 0 0 .504-.493V9.5h1.49a.51.51 0 0 0 .51-.496.51.51 0 0 0-.51-.504H8.5z"
    />
  </svg>
</template>
